import React, {useRef} from 'react';
import _ from 'lodash';
import localeText from '@locale';
import {useSize} from 'ahooks';
import Header from '~/components/Header';
import Banner from '~/components/Banner';
import Content from './Content';
import Doc from '../DocList';
import {getLandingConfig} from '~/utils/tools';
import {LATEST_VERSION} from '~/utils/constant';
import NotFound from '~/components/404';
import BannerBg from '~/assets/images/landing/banner/banner_bg_landingpage.png';
import './index.less';

const LandingPage = ({history, match}) => {
  const {
    params: {locale, version}
  } = match;
  const pageRef = useRef(null);
  const pageSize = useSize(pageRef);
  const landingConfig = getLandingConfig(locale);

  const versionKeys = Object.keys(landingConfig).sort((p, n) => landingConfig[p].order - landingConfig[n].order);
  if (_.indexOf(versionKeys, version) === -1) {
    return <NotFound />;
  }

  return (
    <>
      {LATEST_VERSION.includes(version) ? (
        <div className='landing-page' ref={pageRef}>
          <Header
            locale={locale}
            version={version}
            pageSize={pageSize}
            isTutorial={false}
            configData={landingConfig?.[version]?.header || []}
            versionKeys={versionKeys}
            history={history}
            isLanding
          />
          <Banner
            bannerBg={BannerBg}
            title={localeText('COMMON.TXT_TITLE')}
            description={localeText('COMMON.TXT_DESCRIPTION')}
          />
          <Content configData={landingConfig?.[version]?.content || {}} />
          <div className='copy-right'>{localeText('COMMON.TXT_COPY_RIGHT', new Date().getFullYear())}</div>
        </div>
      ) : <Doc match={{params: {locale, version}}} history={history} />}
    </>

  );
};

export default LandingPage;
